














































import Vue from "vue";

import IconBackspace from "@/components/icons/IconBackspace.vue";
import IconSearch from "@/components/icons/IconSearch.vue";

import { copy, qSet } from "@/services/utils";

function debounce(f: any, ms: number): any {
  let timer: any = null;
  return (...args: any[]) => {
    const onComplete = () => {
      f.apply(null, args);
      timer = null;
    };
    if (timer) {
      clearTimeout(timer);
    }
    timer = setTimeout(onComplete, ms);
  };
}

export default Vue.extend({
  name: "catalog-search-line",
  components: { IconBackspace, IconSearch },
  props: {
    value: {
      default: "",
    },
  },
  data() {
    return {
      inputError: false,
      inputTooltipText: "",
      debouncedSearch: () => null,
      tooltipSettings: {
        placement: "top",
        trigger: "manual",
        classes: ["warning"],
      },
      searchQuery: "",
    };
  },
  watch: {
    $route(n) {
      const query = copy(n.query);
      this.searchQuery = query.q;
    },
  },
  mounted(): void {
    const initial = this.$route.query.q;
    if (initial) this.searchQuery = initial as string;
    (this as any).debouncedSearch = debounce(this.search, 500);
  },
  methods: {
    search() {
      const query = qSet("q", this.searchQuery, copy(this.$route.query));
      this.reroute(qSet("page", null, query));
    },
    reroute(query: any) {
      this.$router.replace({
        path: this.$route.path,
        query,
      });
    },
    clearInput() {
      this.searchQuery = "";
      this.reroute(qSet("q", undefined, copy(this.$route.query)));
    },
  },
});
